
    export default {
        name: "SupportCategoriesCard",
        props: {
            displayTitle: {
                type: String,
                default: ""
            },
            imageUrl: {
                type: String,
                default: ""
            },
            imageAlt: {
                type: String,
                default: ""
            },
            childCategories: {
                type: Array,
                default: []
            },
            onEnterCategory: {
                type: Function,
                default: null
            },
            currentCategory: {
                type: Array,
                default: []
            },
            urlName: {
                type: String,
                default: ""
            }
        }
    };
